module.exports = __webpack_public_path__ + "static/media/ganti_kata_sandi.b78d305c.png";